export const green = {
  95: '#ebf9f1',
  90: '#d7f4e3',
  80: '#b0e8c7',
  70: '#88dda8',
  60: '#61d190',
  55: '#36ba6d',
  40: '#2e9e5d',
  30: '#227745',
  20: '#174f2e',
  10: '#0b2817',
};
